import { Dialog, HelpDrawerToggle, InfoCircleIcon } from '@cmsgov/ds-medicare-gov';
import { useState } from 'react';
import { helpDrawerClosed, helpDrawerOpened } from '../analytics';
import '../css/dialog.css';
import translate from '../functions/translate';
import Button from './button';
import H2 from './h2';
import X from '../../common/images/x.svg';
import Div from './div';

const MedicareCardHelpDialog = () => {

    const [showDialog, setShowDialog] = useState(false);
    const drawerHeading = translate('dialog_mbi_title');

    const toggleDialog = () => {
        if (!showDialog) {
            helpDrawerOpened(drawerHeading, drawerHeading);
        } else {
            helpDrawerClosed(drawerHeading);
        }
        setShowDialog(current => !current);
    };

    return <>
        <Div>
            <HelpDrawerToggle
                helpDrawerOpen={showDialog}
                showDrawer={toggleDialog}
            >
                {translate('dialog_button_card_help')}<InfoCircleIcon className="ds-u-margin-left--05"/>
            </HelpDrawerToggle>
            {showDialog && <Dialog
                className={'drawer-dialog'}
                getApplicationNode={() => document.getElementById('App')}
                headerClassName={'drawer-dialog-header'}
                underlayClickExits={true}
            >
                <div style={{cursor: 'pointer', float: 'right'}}>
                    <Button
                        aria-label={translate('close')}
                        variation={'ghost'}
                        onClick={toggleDialog}
                        noAnalytics
                    >
                        <img
                            alt={translate('close')}
                            src={X}
                            style={{
                                position: 'relative',
                                bottom: 15,
                                left: 15,
                            }}
                        />
                    </Button>
                </div>
                <H2 className="ds-u-margin-bottom--4 ds-u-margin-top--0">
                    {drawerHeading}
                </H2>
                <p className="ds-u-margin-bottom--4">
                    {translate("dialog_mbi_body1")} <a href="https://www.ssa.gov/myaccount/">{translate("dialog_mbi_body2")}</a>
                </p>
                <p>
                    {translate("dialog_mbi_body3")} {' '}
                    <a href='tel:1-800-633-4227'>1-800-633-4227</a>. TTY: <a href='tel:1-877-486-2048'>1-877-486-2048</a>.
                </p>
            </Dialog>}
        </Div>
    </>
}

export default MedicareCardHelpDialog;
